import React from 'react';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';
import { agentInfoFormId } from '../AgentInfo';
import { PresentationMode } from '../../../../../../Enums/PresentationMode';
import SecondaryButton from '../../../../../../Elements/ids/Buttons/SecondaryButton';
import ModalPrimaryButton from '../../../../../../Elements/ids/Buttons/ModalPrimaryButton';
import PrimaryButton from '../../../../../../Elements/ids/Buttons/PrimaryButton';

const AgentInfoButtons = ({ closeView, canSubmit, modalMode, closeError }) => {
  return (
    <>
      <SecondaryButton text={formatMessage(Messages.common_cancel)} onClickEvent={closeView} />

      {modalMode === PresentationMode.Error ? (
        <PrimaryButton text={formatMessage(Messages.common_ok)} onClickEvent={closeError} />
      ) : (
        <ModalPrimaryButton text={formatMessage(Messages.common_save)} formId={agentInfoFormId} canSubmit={canSubmit} />
      )}
    </>
  );
};

export default AgentInfoButtons;
